import {
  GET_DASHBOARD,
  GET_ALLCASES,
  GET_ALL_USERS_DATA,
  GET_ALLCASES_MAP_DATA,
  ADMIN_DASHBOARD_DETAILS,
  GET_GROUP_BASED_USER_DETAILS,
} from '../types'

const INITIAL_STATE = {
  dashboards: null,
  adminDashboard: [],
  userscasesData: [],
  usersDashboard: [],
  groupusersDashboard: [],
  adminDashboardDetails: {},
  lastUpdated: null,
  refreshRequired: false,
  realTimeUpdates: [],
}

const dashboardReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_DASHBOARD:
      return {
        ...state,
        dashboards: payload.data,
        lastUpdated: new Date().toISOString(),
        refreshRequired: false,
      }
    case GET_ALLCASES:
      return {
        ...state,
        adminDashboard: payload.data,
        lastUpdated: new Date().toISOString(),
        refreshRequired: false,
      }
    case GET_ALL_USERS_DATA:
      return {
        ...state,
        userscasesData: payload.data,
        lastUpdated: new Date().toISOString(),
        refreshRequired: false,
      }
    case GET_ALLCASES_MAP_DATA:
      return {
        ...state,
        usersDashboard: payload.data,
        lastUpdated: new Date().toISOString(),
        refreshRequired: false,
      }
    case GET_GROUP_BASED_USER_DETAILS:
      return {
        ...state,
        groupusersDashboard: payload.data,
        lastUpdated: new Date().toISOString(),
        refreshRequired: false,
      }
    case ADMIN_DASHBOARD_DETAILS:
      return {
        ...state,
        adminDashboardDetails: payload.data,
        lastUpdated: new Date().toISOString(),
        refreshRequired: false,
      }
    case 'DASHBOARD_REFRESH_REQUIRED':
      return {
        ...state,
        refreshRequired: true,
        realTimeUpdates: [
          ...state.realTimeUpdates.slice(-9), // Keep last 10 updates
          {
            type: 'refresh_required',
            timestamp: payload.timestamp,
            data: payload,
          },
        ],
      }
    case 'DASHBOARD_SECTION_UPDATE':
      return {
        ...state,
        realTimeUpdates: [
          ...state.realTimeUpdates.slice(-9), // Keep last 10 updates
          {
            type: 'section_update',
            section: payload.section,
            timestamp: payload.timestamp,
            data: payload.data,
          },
        ],
      }
    case 'CLEAR_DASHBOARD_UPDATES':
      return {
        ...state,
        realTimeUpdates: [],
        refreshRequired: false,
      }
    default:
      return state
  }
}

export default dashboardReducer
